import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56a6d1b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "assets_ratio" }, [
    /*#__PURE__*/ _createElementVNode("canvas", { id: "assets_ratio_chart" })
], -1));
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = { class: "assets_cards" };
const _hoisted_6 = { key: 3 };
import { onMounted, ref, onErrorCaptured, watch } from 'vue';
import RefreshWarn from '@/materials/atoms/RefreshWarn.vue';
import Loading from '@/materials/molecules/Loading.vue';
import ConnectionError from '@/materials/atoms/ConnectionError.vue';
import { useAssetsRatioGraph } from '@/logics/assets_ratio';
import CryptoCard from '@/components/organisms/main/staking/stakingdashboard/CryptoCard.vue';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const isError = ref(false);
        const { refresh } = useAssetsRatioGraph();
        onErrorCaptured(() => {
            isError.value = true;
        });
        if (props.isAuth) {
            onMounted(refresh);
            watch(() => [store.state.userSettings.language, store.state.isSmartPhone], refresh);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!isError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _hoisted_2
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            error: _withCtx(() => [
                                _createVNode(ConnectionError)
                            ]),
                            _: 1
                        }))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(RefreshWarn)
                    ])),
                (!isError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(CryptoCard, {
                                        "is-auth": props.isAuth
                                    }, null, 8, ["is-auth"])
                                ])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            error: _withCtx(() => [
                                _createVNode(ConnectionError)
                            ]),
                            _: 1
                        }))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(RefreshWarn)
                    ]))
            ], 64));
        };
    }
});
